import React from 'react'
import './Button.scss'

const Button = (props) => {

    let { variant, children, ...forwardProps } = props

    let buttonClass = ''
    switch (variant.toUpperCase()) {
        case 'PRIMARY':
            buttonClass = 'primary'
            break
        case 'PRIMARY-LIGHT':
            buttonClass = 'primarylight'
            break
        case 'SECONDARY':
            buttonClass = 'secondary'
            break
        case 'SUCCESS':
            buttonClass = 'btn-success'
            break
        case 'DANGER':
            buttonClass = 'btn-danger'
            break
        default: break;
    }

    forwardProps.className = `button ${buttonClass} ${forwardProps.className ? forwardProps.className : ''}`

    return (
        <button {...forwardProps}>{children}</button>
    )
}

Button.defaultProps = {
    variant: 'primary',
    onClick: () => { }
}

export default Button
